var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.background},[_c('span',[_vm._v("Nazovite nas")]),_vm._v(" "),_c('a',{class:_vm.astyle,attrs:{"href":("tel:" + (_vm.constants.phone))}},[_c('icon',{attrs:{"name":"phone","scale":"2"}}),_vm._v(" "+_vm._s(_vm.constants.phoneShort))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-400a9d8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cCallUs.vue
// module id = null
// module chunks = 